<script>
    import { createEvent } from 'shared/eventBus';

    export default {
        props: {
            value: String,
            name: String,
            label: String,            
            disabled: Boolean,
            noLabelMargin: Boolean,
            inputEmitChange: Boolean
        },
        computed: {
            radioButtonValue: {
                get: function() {
                    return this.value
                },
                set: function() {
                    // Communicate the change to parent component so that selectedValue can be updated
                    this.$emit("change", this.value);
                }
            }
        },
        methods: {
            input(e) {
                var val = e.target.value;
                this.$emit('input', val);
                
                if (this.inputEmitChange) {
                    this.$emit('change', val);
                }
                
                this.$el.dispatchEvent(createEvent("change"));

                if(val) {
                    //Emit global event to tell other radio buttons they changed
                    this.$root.$emit(`${this.name}_selected`, this._uid);
                }
            }
        }
    }
</script>

<template>
    <label class="radio-container">
        <input type="radio" :value="label" :name="name" v-model="radioButtonValue" :disabled="disabled" @change="input">
        <span class="radio-button" ref="radio-button"></span>
        <span class="radio-label" :class="{ 'radio-label-no-margin': noLabelMargin }" v-html="label" />
    </label>
</template>

<style lang="less" scoped>
    @import "~less-variables";
    @import "~less-mixins";

    .radio-container {
        display: inline-block;
        position: relative;
        padding-left: 33px;
        margin-right: 20px;
        cursor: pointer;
        -webkit-user-select: none;
        -moz-user-select: none;
        -ms-user-select: none;
        user-select: none;

        .radio-label {
            display: flex;
            width: 100%;
            justify-content: space-between;
            word-break: break-word;
            margin-top: 4px;
        }

        .radio-label-no-margin {
            margin: 0;
        }
        
        input {
            position: absolute;
            opacity: 0;
            cursor: pointer;
            height: 0;
            width: 0;
                &:checked ~ .radio-button {
                background-color: #ffffff;

                &:after {
                    display: block;
                }
            }
        }

        &:hover {
            input {
                &~.radio-button {
                    background-color: #ccc;
                }
            }
        }

        .radio-button {
            &:after {
                top: 5px;
                left: 5px;
                width: 8px;
                height: 8px;
                border-radius: 50%;
                background: #00acec;
            }
        }

        .radio-button {
            position: absolute;
            top: 3px;
            left: 0;
            height: 22px;
            width: 22px;
            background-color: #ffffff;
            border-radius: 50%;
            border: 2px solid #00acec;
            box-shadow: 0 0 2px rgba(0, 0, 0, 0.2);

            &:after {
                content: "";
                position: absolute;
                display: none;
            }
        }
    }    

    body.user-is-tabbing {
        .radio-container:focus-within {
            border: 2px dotted white;
        }
    }
</style>